import anime from 'animejs'
import { isEqual } from 'lodash-es'
import { useEffect, useRef, useState } from 'react'

const useNavigation = (containerRef, trayRef, position, setPosition) => {
  let [arrow, setArrow] = useState({
    hasPrevious: false,
    hasNext: false,
  })

  let handler = useRef()

  handler.current = () => {
    let containerWidth = containerRef.current.offsetWidth
    let trayWidth = trayRef.current.offsetWidth

    let newArrow = {
      hasPrevious: position < 0,
      hasNext: position > containerWidth - trayWidth,
    }

    if (!isEqual(arrow, newArrow)) {
      setArrow(newArrow)
    }
  }

  useEffect(() => {
    handler.current()
  }, [position])

  useEffect(() => {
    let tray = trayRef.current

    let observer = new ResizeObserver(() => {
      handler.current()
    })

    observer.observe(tray)

    return () => {
      observer.unobserve(tray)
    }
  }, [trayRef])

  let moveSlide = direction => {
    let containerWidth = containerRef.current.offsetWidth
    let trayWidth = trayRef.current.offsetWidth

    let distance = containerWidth * -direction

    if (position + distance > 0) {
      distance = -position
    }

    if (position + distance < containerWidth - trayWidth) {
      distance = containerWidth - trayWidth - position
    }

    anime({
      targets: trayRef.current,
      translateX: position + distance,
      duration: Math.abs(distance),
      easing: 'easeInOutCubic',
      complete: () => {
        setPosition(position + distance)
      },
    })
  }

  return { arrow, moveSlide }
}

export default useNavigation
